module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("$t is not defined")]), _vm._v(" "), _c('p', [_vm._v("一般是两个原因：")]), _vm._v(" "), _c('h2', [_vm._v("cnpm 导致的问题")]), _vm._v(" "), _c('p', [_vm._v("如果是直接使用模板后并且使用 "), _c('code', [_vm._v("cnpm")]), _vm._v(" 报错，请升级到 "), _c('code', [_vm._v("vux-loader@1.0.58")]), _vm._v("。")]), _vm._v(" "), _c('p', [_vm._v("该问题出现原因是 "), _c('code', [_vm._v("cnpm")]), _vm._v(" 安装后 "), _c('code', [_vm._v("node_modules")]), _vm._v(" 里的模块为快捷方式，而 "), _c('code', [_vm._v("vux-loader")]), _vm._v(" 之前版本没有考虑到这一特殊情况。")]), _vm._v(" "), _c('h2', [_vm._v("未正确配置动态 i18n")]), _vm._v(" "), _c('p', [_vm._v("demo例子使用"), _c('code', [_vm._v("$t")]), _vm._v("是因为demo启用了"), _c('code', [_vm._v("i18n")]), _vm._v("，如果你没有使用"), _c('code', [_vm._v("vuex-i18n")]), _vm._v("等相关"), _c('code', [_vm._v("i18n")]), _vm._v("插件，请不要在代码中使用"), _c('code', [_vm._v("$t")]), _vm._v("函数")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-35bf379d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-35bf379d"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/$t-is-not-defined-9.vue
// module id = 2145
// module chunks = 481